import styled from 'styled-components';
import { SColumn } from 'styles/layout';
import { SBoldPrimaryText } from 'styles/components';

// La chaîne s'affiche en ligne dans la sidebar de la fiche : pas de hauteur max ni de scroll,
// le contenu suit le flux naturel de la page.
export const SChain = styled(SColumn)`
    width: 100%;
    align-items: center;
    gap: 0;
    padding: 0.5rem 0;

    & > div {
        width: 100%;
    }
`;

export const SChainNode = styled.div`
    width: 100%;
    cursor: pointer;
    border-radius: 5px;
    transition: opacity 0.15s ease;

    &:hover {
        opacity: 0.85;
    }
`;

export const SConnector = styled.div`
    display: flex;
    justify-content: center;
    padding: 0.4rem 0;
    fill: ${({ theme }) => theme.color.secondary.main};

    svg {
        width: 1.8rem;
        height: 1.8rem;
    }
`;

export const SYouNode = styled(SBoldPrimaryText)`
    padding: 1rem 2.4rem;
    border-radius: 5px;
    background-color: ${({ theme }) => theme.color.secondary.main};
    color: ${({ theme }) => theme.color.white};
    text-transform: uppercase;
`;
